<template>
  <section class="container hero">
    <div class="wrapper">
      <div class="hero-text">
        <h2 class="hero-text__title">
          <span class="underlined-text underlined-text--light-gold">Growing
          </span> your business across Asia</h2>
      </div>
      <div class="hero__illustration">
        <img src="@/assets/img/header-illustration.png" srcset="@/assets/img/header-illustration@2x.png 2x, 
          @/assets/img/header-illustration@3x.png 3x">
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.hero {
  margin-bottom: 80px;
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  @media (min-width: $laptop-s) {
    margin-bottom: 120px;
  }
}

.hero-text {
  z-index: 1;
  max-width: $phone-l;
  margin: 0 auto;
  padding-right: 10px;
  @media (min-width: $tablet) {
    max-width: none;
  }
}

.hero-text__title {
  font-size: 2.5em;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 16px;
  letter-spacing: -1px;
  @media (min-width: $tablet) {
    font-size: 3em;
  }
  @media (min-width: $laptop-s) {
    font-size: 4em;
    margin-bottom: 0;
  }
  @media (min-width: $laptop-l) {
    font-size: 4.4em;
  }
}

.hero-text__subtitle {
  letter-spacing: -0.1px;
}

.hero__illustration {
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  width: 100%;
  max-width: $phone-l;
  text-align: center;
  @media (min-width: $tablet) {
    max-width: none;
    margin-top: 0;
  }
  z-index: -1;
}

.hero-text,
.hero__illustration {
  @media (min-width: $tablet) {
    width: 50%;
    position: relative;
  }
}
</style>

